import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "esign-contract-wrapper"
}
const _hoisted_2 = { class: "custom-dialog" }
const _hoisted_3 = { class: "dialog-header" }
const _hoisted_4 = { class: "dialog-body" }
const _hoisted_5 = {
  key: 0,
  class: "dialog-content"
}
const _hoisted_6 = { class: "company-info" }
const _hoisted_7 = { class: "warning-text" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "dialog-content"
}
const _hoisted_11 = { class: "sign-info-text" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "link-section" }
const _hoisted_15 = { class: "link-url" }
const _hoisted_16 = { class: "dialog-footer" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_ctx.dialogVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "custom-overlay" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "dialog-title" }, "授权代表信息", -1)),
            (_ctx.canClose)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "dialog-close",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
                }, "×"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.currentStep === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, " 签署企业：" + _toDisplayString(_ctx.companyName), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                    placeholder: "请输入企业授权代表姓名",
                    disabled: !_ctx.isSupPcAdmin,
                    class: "input-item"
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.phone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.phone) = $event)),
                    placeholder: "请输入企业授权代表手机号",
                    disabled: !_ctx.isSupPcAdmin,
                    class: "input-item"
                  }, null, 8, ["modelValue", "disabled"]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[9] || (_cache[9] = _createTextVNode(" *请超管输入企业指定签署授权代表信息， ")),
                    (_ctx.days>0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "最迟" + _toDisplayString(_ctx.days) + "天后还未签署的客户，将限制使用", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "产品限制使用，请立即签署"))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentStep === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(" *请签署授权代表" + _toDisplayString(_ctx.signerName) + "前往签署《" + _toDisplayString(_ctx.fileName) + "》， ", 1),
                    (_ctx.days>0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "最迟" + _toDisplayString(_ctx.days) + "天后还未签署的客户，将限制使用", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, "产品限制使用，请立即签署"))
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "link-label" }, "链接：", -1)),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.signUrl), 1),
                    _createElementVNode("span", {
                      class: "link-copy",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)))
                    }, "复制")
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tip-text" }, " 签署完成后，大概1分钟以后点击刷新 ", -1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.currentStep === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.canClose)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-default",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleIgnore && _ctx.handleIgnore(...args)))
                      }, "忽略"))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn btn-primary", { 'btn-disabled': !_ctx.isSupPcAdmin }]),
                    disabled: !_ctx.isSupPcAdmin,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args)))
                  }, " 确定 ", 10, _hoisted_17)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.currentStep === 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.canClose)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-default",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
                      }, "取消"))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
                  }, "刷新")
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}